// importando estilização do componente
import { ButtonActionWide } from '../../buttons/actionWide/ButtonActionWide';
import { Styled } from './Styled'
import icons from '../../../../img/icons/icons';
import { ButtonClose } from '../../buttons/close/ButtonClose';
import { CoursesServices, ICourses } from '../../../Services/api/courses/courses.services';
import { IPicture, picturesServices } from '../../../Services/api/pictures/picturesServices';
import { useEffect, useState } from 'react';
import { ITrainingArea, TrainingAreaServices } from '../../../Services/api/trainingArea/TrainingArea.services';
import { ContentsServices, IContent } from '../../../Services/api/contents/Contents.services';
import { ContentItem } from './ContentItem/ContentItem';

interface IFullCursoProps {
    id: string;
    onClose: () => void;
}
export const FullCurso: React.FC<IFullCursoProps> = (data) => {

    const [course, setCourse] = useState<ICourses | null>(null);
    const [loading, setLoading] = useState(true);
    const [picture, setPicture] = useState<IPicture>();
    const [trainingArea, setTrainingArea] = useState<ITrainingArea | null>(null);
    const [AllContents, setAllContents] = useState<IContent[]>([]);
    const [trainingAreaPicture, setTrainingAreaPicture] = useState<IPicture>();
    const NoIMG = icons.NoIMG;

    useEffect(() => {
        const fetchCourse = async () => {
            setLoading(true);
            const result = await CoursesServices.getCourseById(data.id);
            if (!(result instanceof Error)) {
                setCourse(result);
                await picturesServices.getPictureByID(result.PictureId || '').then((result) => {
                    if (!(result instanceof Error)) {
                        setPicture(result);
                    } else {
                        setPicture(undefined);
                    }
                })
                await TrainingAreaServices.getTrainingAreaById(result.TrainingAreaId || '').then((result) => {
                    if (!(result instanceof Error)) {
                        setTrainingArea(result);

                    } else {
                        setTrainingArea(null);
                    }
                })


            } else {
                setCourse(null);
            }
            setLoading(false);
        };
        fetchCourse();
    }, [data.id]);

    useEffect(() => {
        const fetchTrainingArea = async () => {
            if (trainingArea) {
                await picturesServices.getPictureByID(trainingArea.PictureId || '').then((result) => {
                    if (!(result instanceof Error)) {
                        setTrainingAreaPicture(result);
                    } else {
                        setTrainingAreaPicture(undefined);
                    }
                })
            }
        }
        fetchTrainingArea();
    }, [trainingArea]);

    // Fetch GetAllContentsInCourse here and set to AllContents
    useEffect(() => {
        const fetch = async () => {
            await ContentsServices.getAllCotentsInCourseByCourseId(data.id)
                .then(response => {
                    if (response instanceof Error) {
                        console.log(response.message);
                        setAllContents([]);
                    } else if (Array.isArray(response)) {
                        // Filtra apenas objetos que têm _id e Name
                        const validContents = response.filter(
                            (item: any) => item && typeof item._id === 'string' && typeof item.Name === 'string'
                        );
                        setAllContents(validContents as IContent[]);
                    } else {
                        setAllContents([]);
                    }
                });
        }
        fetch();
    }, [data.id]);
    const closeComponent = () => {
        console.log("closeComponent")
    }

      const clickMatricule = (CourseName: string) => {
        // abre coversa no whatsApp
        const phoneNumber = '55984544008'; // Substitua pelo número de telefone desejado
        const message = `Olá, tenho interesse em me matricular no curso ${CourseName}.`;
        const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    }

    return (
        <Styled.Content>
            <div className='ImgArea'>
                <div className='CloseArea'>
                    <ButtonClose onClick={data.onClose} />
                </div>
                <img src={picture ? `${picture.url}` : NoIMG} alt={course ? course.Name : ''} />
            </div>

            <div className='InfoArea'>
                <div className='TitleCurso'>
                    <img src={trainingAreaPicture ? `${trainingAreaPicture.url}` : NoIMG} alt="" />
                    <span>{course ? course.Name : ''}</span>
                </div>
                <div className='DescriptionCurso'>
                    <p>
                        {course ? course.Description : ''}
                        {"\n \n Conteúdos do curso: \n \n"}
                         {AllContents.map((content) => (
                            
                            <ContentItem key={content._id} contentId={content._id} />
                        ))
                    }
                    </p>
                </div>

            </div>



            <div className='ButtonArea'>
                <ButtonActionWide click={() => clickMatricule(course ? course.Name : '')} nome="Matricule-se" />
            </div>
        </Styled.Content>
    )
}
// aqui estamos exportando nosso componente
